import { object, string } from "zod";

export const SignupWaitlistSchema = object({
  email: string().email(),
});
